module.exports = "<app-resolve promise=\"$ctrl.promise\">\r\n  <div align=\"center\"\r\n      ng-if=\"::!$ctrl.data.length\">\r\n    <div class=\"padding-md margin-md\">\r\n      No hay finiquitos completados.\r\n    </div>\r\n  </div>\r\n  <nominas-finiquitos-completados-lista\r\n      ng-if=\"::$ctrl.data.length\"\r\n      data=\"$ctrl.data\"></nominas-finiquitos-completados-lista>\r\n</app-resolve>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/finiquitos/components/completados/template.html
// module id = 1001
// module chunks = 0